import { SelectionIndividualEvent } from './internal';
export class SelectionIndividualAttribute extends SelectionIndividualEvent {
    getType() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionIndividualAttribute.js.map